export enum TransactionType {
  ERROR = "ERROR",
  SUCCESS = "SUCCESS",
  WARNING = "WARNING",
  INFO = "INFO",
}

export type IIndexableTransaction = {
  [key in TransactionType]: {
    icon: any;
  };
};

export type SubHeaderType = {
  key: string;
  name: string;
  link: string;
};

export type SideBarDataType = {
  title: string;
  key: string;
  isComingSoon?: boolean;
  isDisabled?: boolean;
  link?: string;
  isExternal?: boolean;
  data?: SideBarDataType[];
  eventName?: string;
  isNew?: boolean;
  isLedgerEnabld?: boolean;
};

export type StrategyAllocationType = {
  strategy_name: string;
  img_url: string;
  apr_on_allocation: string;
  allocation: string;
  apr: string;
  realized_apr: string;
  accruing_apr: string;
};

export type TimeframeOption = "7D" | "1M" | "3M" | "6M" | "YTD" | "ALL";
